/* eslint-disable */
/*!
 * getusermedia-js
 * v1.0.0 - 2015-12-20
 * https://github.com/addyosmani/getUserMedia.js
 * (c) Addy Osmani; MIT License
 */ !(function (a, b) {
    "use strict";
    a.getUserMedia = function (c, d, e) {
        if (void 0 !== c)
            if (
                ((navigator.getUserMedia_ =
                    navigator.getUserMedia ||
                    navigator.webkitGetUserMedia ||
                    navigator.mozGetUserMedia ||
                    navigator.msGetUserMedia),
                navigator.getUserMedia_)
            ) {
                var f,
                    g,
                    h,
                    i,
                    j,
                    k = {},
                    l = "";
                c.video === !0 && ((k.video = !0), (l = "video")),
                    c.audio === !0 &&
                        ((k.audio = !0),
                        "" !== l && (l += ", "),
                        (l += "audio")),
                    (f = b.getElementById(c.el)),
                    (g = b.createElement("video")),
                    (i = parseInt(f.offsetWidth, 10)),
                    (j = parseInt(f.offsetHeight, 10)),
                    c.width < i &&
                        c.height < j &&
                        ((c.width = i), (c.height = j)),
                    (g.width = c.width),
                    (g.height = c.height),
                    (g.autoplay = !0),
                    f.appendChild(g),
                    (h = g),
                    (c.videoEl = h),
                    (c.context = "webrtc");
                try {
                    navigator.getUserMedia_(k, d, e);
                } catch (m) {
                    try {
                        navigator.getUserMedia_(l, d, e);
                    } catch (n) {
                        return;
                    }
                }
            } else if (void 0 === c.noFallback || c.noFallback === !1) {
                var o, p, q;
                (o =
                    '<!--[if IE]><object id="XwebcamXobjectX" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="' +
                    c.width +
                    '" height="' +
                    c.height +
                    '"><param name="movie" value="' +
                    c.swffile +
                    '" /><![endif]--><!--[if !IE]>--><object id="XwebcamXobjectX" type="application/x-shockwave-flash" data="' +
                    c.swffile +
                    '" width="' +
                    c.width +
                    '" height="' +
                    c.height +
                    '"><!--<![endif]--><param name="FlashVars" value="mode=' +
                    c.mode +
                    "&amp;quality=" +
                    c.quality +
                    '" /><param name="allowScriptAccess" value="always" /></object>'),
                    (p = b.getElementById(c.el)),
                    (p.innerHTML = o),
                    (function r(f) {
                        (q = b.getElementById("XwebcamXobjectX")),
                            void 0 !== q.capture
                                ? ((c.capture = function (a) {
                                      try {
                                          return q.capture(a);
                                      } catch (b) {}
                                  }),
                                  (c.save = function (a) {
                                      try {
                                          return q.save(a);
                                      } catch (b) {}
                                  }),
                                  (c.setCamera = function (a) {
                                      try {
                                          return q.setCamera(a);
                                      } catch (b) {}
                                  }),
                                  (c.getCameraList = function () {
                                      try {
                                          return q.getCameraList();
                                      } catch (a) {}
                                  }),
                                  (c.context = "flash"),
                                  (c.onLoad = d))
                                : 0 === f
                                ? e()
                                : a.setTimeout(r, 1e3 * (4 - f), f - 1);
                    })(3);
            }
    };
})(this, document);
/* eslint-enable */
